import { render, staticRenderFns } from "./TeacherViewTabStudy.vue?vue&type=template&id=5d69232c&"
import script from "./TeacherViewTabStudy.vue?vue&type=script&lang=js&"
export * from "./TeacherViewTabStudy.vue?vue&type=script&lang=js&"
import style0 from "./TeacherViewTabStudy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports